/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import {CustomCheckbox} from "../../../../../../../../components/CustomCheckbox";

/**
 * Return of the vehicle required by the movement.
 *
 * The requirement is only displayed, never edited, because it is captured when
 * the form is registered and the guard at the gate is the one that completes it.
 *
 * A movement that comes into the plant is closed with the departure of the
 * vehicle, so the labels it is read with travel with it.
 *
 * @param {Function} t - Translation handler.
 * @param {string} title - Title the requirement is read with.
 * @param {string} description - Text that says what the folio waits for.
 * @param {string} id - Identifier of the checkbox, so a folio that waits for
 * both movements of the gate reads each one with its own.
 * @param {boolean} required - Whether the folio waits for the movement, because
 * the one that travels one way declares it as well and is read saying so.
 */
const VehicleArrivalSection = ({
                                   t,
                                   title = 'vehicle_arrival',
                                   description = 'the_folio_will_stay_open_until_the_arrival_is_registered',
                                   id = 'vehicle_arrival',
                                   required = true
                               }) => {
    return (
        <>
            <p className='font-color-general-950 fs-14px ibl-font-w-600 px-0'>{t(title)}</p>
            <div className='col-12 px-0'>
                <div className='d-flex flex-grow-1 minw-0 justify-content-start align-items-center p-0'>
                    <div className={"mr-2 d-flex align-items-center"}>
                        <CustomCheckbox
                            marginbutton={true}
                            id={`cb_vas_${id}_required`}
                            checked={required}
                            value={''}
                            labelId={`lbl_vas_${id}_required`}
                            name={`${id}Required`}
                            disabled={true}
                        />
                    </div>
                    <p className={"fs-14px mb-0"}>
                        {required
                            ? `${t('required')} — ${t(description)}`
                            : `${t('not_required')} — ${t('one_way_trip')}`}
                    </p>
                </div>
            </div>
        </>
    );
};

export default VehicleArrivalSection;
